<div class="sidebar" *ngIf="isDesktop || !isInnerPage">
  <div class="sidebar-main">
    <app-deployment-details></app-deployment-details>
    <app-submit-post-button
      class="sidebar__add-post-btn"
      [isRound]="false"
      [hasIconOnly]="false"
      [hasText]="true"
      *ngIf="checkAllowedAccessToSite()"
    >
    </app-submit-post-button>

    <nav class="sidebar__controls">
      <app-menu-list-links></app-menu-list-links>
      <app-menu-list-non-links></app-menu-list-non-links>
    </nav>
  </div>

  <div class="sidebar-footer">
    <a href="https://arsenaldemocracy.org" target="_blank"
      ><img src="../../../../../assets/images/project-of-arsenal.svg"
    /></a>

    <!-- Settings link for authorized users -->
    <a
      *ngIf="canAccessSettings"
      class="footer-settings-link"
      routerLink="/settings"
      routerLinkActive="sidebar-menu-button--active"
    >
      <mat-icon class="footer-settings-icon" svgIcon="settings"></mat-icon>
      <span class="footer-settings-text">{{ 'nav.settings' | translate }}</span>
    </a>

    <mzima-client-button
      class="donate-btn"
      type="button"
      target="_blank"
      href="https://secure.actblue.com/donate/resistmap?refcode=website-footer"
      fill="outline"
      color="transparent-style-1"
    >
      {{ 'app.donate' | translate }}
    </mzima-client-button>

    <!-- About button -->
    <mzima-client-button
      class="about-btn"
      type="button"
      fill="outline"
      color="transparent-style-1"
      (buttonClick)="openAboutModal()"
    >
      {{ 'nav.about' | translate }}
    </mzima-client-button>
  </div>
</div>
